import { useCampaignSlug } from '@/components/Functional/hooks-core/useCampaignSlug'
import { Dialog } from '@/components/UI/Dialog'
import { useTranslation } from 'react-i18next'

type Language = {
  id: number
  name: string
  label: string
  code: string
}

type Props = {
  isOpen: boolean
  onClose: () => void
  languages: Language[]
}

export function LanguageDialog({ isOpen, onClose, languages }: Props) {
  const { i18n } = useTranslation()
  const { LOCAL_STORAGE_I18N_KEY } = useCampaignSlug()

  const handleChange = (code: string) => {
    i18n.changeLanguage(code, () => {
      localStorage.setItem(LOCAL_STORAGE_I18N_KEY, code)
    })
    onClose()
  }

  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title="Language">
      <ul className="flex flex-col gap-3 px-4 py-4">
        {languages.map((lang) => (
          <li key={lang.id}>
            <button
              type="button"
              onClick={() => handleChange(lang.code)}
              className={`w-full rounded-lg border px-4 py-3 text-left text-h1 font-bold transition-colors
                ${i18n.language === lang.code ? 'border-main text-main' : 'border-gray-200 text-gray-700'}`}
            >
              {lang.label}
            </button>
          </li>
        ))}
      </ul>
    </Dialog>
  )
}
